(ns practitest.frontend.components2.dashboard.charts.stacked-bar
  (:require [practitest.frontend.components2.dashboard.charts.render :as r]
            [practitest.frontend.components2.dashboard.charts.common :as c]
            [practitest.frontend.components2.dashboard.chart :as-alias chart]
            [practitest.frontend.components2.dashboard.charts.protocol :as p]
            [practitest.frontend.components2.dashboard.transforms.stacked-bar :as transforms]
            [practitest.frontend.components2.dashboard.events :as-alias events]
            [re-frame.core :as rf]))

(def chart-custom-specs
  {::chart/stacked-bar {:encode {:x       {:axis {:format "%y-%m-%d"}}
                                 :tooltip {:mode :category-group}}}
   ::chart/age         {:encode {:tooltip {:mode :category-value}}}})

(defn base-spec [chart]
  (let [toggle-evt    #(rf/dispatch [::events/toggle-legend-item (:chart/id chart) %])
        palette       (:chart/colors-palette chart)
        series-labels (:chart/series chart)
        ordered-range (mapv (fn [label] (get palette label)) series-labels)
        legend?       (not= :no-legend (:chart/legend-location chart))]
    {:mark    :bar
     :padding {:top 5 :right 20 :bottom 35 :left 35}
     :tooltip true
     :data    (:chart/data chart)
     :encode  {:x     {:field :category
                       :type  :nominal
                       :axis  {:label-angle -40}
                       :scale {:domain        (:chart/categories chart)
                               :padding-inner 0.4
                               :padding-outer 0.2}}
               :y     {:field   :value
                       :type    :quantitative
                       :stacked true
                       :axis    {:tick-min-step 1}}
               :color
               (cond-> {:field :group
                        :type  :nominal
                        :scale {:domain series-labels
                                :range  ordered-range}}

                       legend?
                       (assoc :legend {:opacity {:one-of (:chart/inactive-groups chart)}
                                       :offset 60}))}
     :on-legend-click toggle-evt}))

(defmethod p/render! ::chart/stacked-bar [chart _ctx svg-element]
  (->> (get chart-custom-specs (:chart/type chart) {})
       (c/deep-merge (base-spec chart))
       (r/render-chart! svg-element)))

(defmethod p/transform-data ::chart/stacked-bar [chart]
  (transforms/transform chart))

(derive ::chart/age ::chart/stacked-bar)
